function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 19"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.193 0 0 2.193l7.124 7.14L0 16.473l2.193 2.194 9.334-9.334z",
    style: {
      fill: "currentColor"
    }
  }));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTkiCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8c3R5bGU+CiAgICAgIC5pY29uIHsKICAgICAgICBmaWxsOiBjdXJyZW50Q29sb3I7CiAgICAgIH0KICA8L3N0eWxlPgogIDxwYXRoIGNsYXNzPSJpY29uIiBkPSJNMi4xOTMzMyAwTDAgMi4xOTMzM0w3LjEyNDQ0IDkuMzMzMzNMMCAxNi40NzMzTDIuMTkzMzMgMTguNjY2N0wxMS41MjY3IDkuMzMzMzNMMi4xOTMzMyAwWiIgLz4KPC9zdmc+";